export enum Employers {
  GET_EMPLOYERS_REQUEST = '@employers/GET_EMPLOYERS_REQUEST',
  GET_EMPLOYERS_SUCCESS = '@employers/GET_EMPLOYERS_SUCCESS',
  GET_EMPLOYERS_FAIL = '@employers/GET_EMPLOYERS_FAIL',

  GET_USER_DASHBOARD_EMPLOYERS_REQUEST = '@employers/GET_USER_DASHBOARD_EMPLOYERS_REQUEST',
  GET_USER_DASHBOARD_EMPLOYERS_SUCCESS = '@employers/GET_USER_DASHBOARD_EMPLOYERS_SUCCESS',
  GET_USER_DASHBOARD_EMPLOYERS_FAIL = '@employers/GET_USER_DASHBOARD_EMPLOYERS_FAIL',

  GET_EMPLOYER_SITES_REQUEST = '@employers/GET_EMPLOYER_SITES_REQUEST',
  GET_EMPLOYER_SITES_SUCCESS = '@employers/GET_EMPLOYER_SITES_SUCCESS',
  GET_EMPLOYER_SITES_FAIL = '@employers/GET_EMPLOYER_SITES_FAIL',
}
